








































import { Component } from 'vue-property-decorator';
import IssueItemBaseMixin from '@/components/ViewComponent/Issue/IssueItem/issue-item-base.mixin';
import IdeaIcon from '@/components/Helper/Icon/Svg/IdeaIcon.vue';
import ReactionItem from '@/components/ViewComponent/Issue/Reaction/ReactionItem.vue';
import { service } from '@/services/service';
import IssueReactionService from '@/services/issue-reaction.service';
import AddReactionButton from '@/components/ViewComponent/Issue/Reaction/AddReactionButton.vue';

@Component<IssueDetailDescriptionPc>({
  components: { AddReactionButton, ReactionItem, IdeaIcon },
})
export default class IssueDetailDescriptionPc extends IssueItemBaseMixin {
  // eslint-disable-next-line class-methods-use-this
  get reactionService() {
    return service(IssueReactionService);
  }
}
